import dayjs, { Dayjs } from "utils/dayjs"

import RentToBuyEvent, { IGetRentToBuyEventDTO } from "./RentToBuyEvent"

export interface IGetRentToBuyChecklistDTO {
    entities: IGetRentToBuyEventDTO[]
    periodsToBeChecked: string[]
}

export default class RentToBuyChecklist {
    events: RentToBuyEvent[]
    periodsToBeChecked: Dayjs[]

    constructor(dto: IGetRentToBuyChecklistDTO) {
        this.events = dto.entities.map(eventDTO => new RentToBuyEvent(eventDTO))
        this.periodsToBeChecked = dto.periodsToBeChecked.map(period => dayjs(period, "YYYY-MM"))
    }
}

export enum RentToBuyChecklistSortBy {
    startDate = "startDate",
    endDate = "endDate",
    requestNo = "requestNo",
    approval = "approval",
}
